import * as React from "react";
import { useLiveVehicles } from "./useLiveVehicles";

type Args = {
  map: google.maps.Map | null;
};

export function useTransitLiveTraffic({ map }: Args) {
  const [showLiveByLine, setShowLiveByLine] = React.useState<Set<string>>(
    new Set()
  );

  const liveLineIds = React.useMemo(
    () => Array.from(showLiveByLine),
    [showLiveByLine]
  );

  const {
    liveOverlayByLine,
    startLiveForLine,
    stopLiveForLine,
    stopAllLive,
    unavailableLineIds,
    lineStates,
  } = useLiveVehicles({ map });

  const onToggleShowLiveForLine = React.useCallback(
    (lineId: string, checked: boolean) => {
      setShowLiveByLine((prev) => {
        const next = new Set(prev);

        if (checked) next.add(String(lineId));
        else next.delete(String(lineId));

        return next;
      });
    },
    []
  );

  React.useEffect(() => {
    if (!map) return;

    const wanted = new Set(Array.from(showLiveByLine).map(String));

    const running = new Set(Object.keys(liveOverlayByLine).map(String));

    running.forEach((id) => {
      if (!wanted.has(id)) {
        stopLiveForLine(id);
      }
    });

    wanted.forEach((id) => {
      if (!running.has(id)) {
        startLiveForLine(id);
      }
    });
  }, [
    map,
    showLiveByLine,
    liveOverlayByLine,
    startLiveForLine,
    stopLiveForLine,
  ]);
  React.useEffect(() => {
    return () => {
      stopAllLive();
    };
  }, [stopAllLive]);

  return {
    showLiveByLine,
    setShowLiveByLine,
    liveLineIds,
    liveOverlayByLine,
    unavailableLineIds,
    lineStates,
    stopLiveForLine,
    stopAllLive,
    onToggleShowLiveForLine,
  };
}
